module.exports = __webpack_public_path__ + "static/media/SourceSansPro-It.389158cf.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-It.woff
// module id = 337
// module chunks = 3